export enum PaymentStatus {
  COLLECTED = 'collected',
  PARTIALLY_COLLECTED = 'partially_collected',
  OVERDUE = 'overdue',
  PENDING = 'pending',
  CANCELED = 'canceled',
  REFUNDED = 'refunded'
}
